import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { type Types, getApplicationLabels } from 'modules/app_store/lib/getApplicationLabels'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

interface Props {
  subscriptionAddon: SubscriptionAddon
  onSubmit: () => void
  onClose: () => void
}

const UninstallAddon = ({ subscriptionAddon, onSubmit, onClose }: Props) => {
  const id = subscriptionAddon.attributes.id
  // FIXME: sorry for this any, but we arrived late to the party
  const { title, uninstall } = getApplicationLabels(subscriptionAddon.type as Types, id)
  const defaultUninstall = i18n.t('app_store_v2.common.uninstall.description')

  return (
    <Modal
      illustration="uninstall"
      title={i18n.t('app_store_v2.common.uninstall.title', {
        app_name: title,
      })}
      description={uninstall || defaultUninstall}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onSubmit}>{i18n.t('app_store_v2.common.uninstall.submit')}</Button>
        </>
      }
    />
  )
}

export default observer(UninstallAddon)
